<template>
  <v-container>
    <div v-for="(tags, group) in tagGroups" :key="group">
      <h2 class="heading font-weight-light primary--text">{{ group }}</h2>
      <v-layout wrap mt-2>
        <recipe-tag
          v-for="tag in tags"
          :key="tag"
          :value="tag"
          :active="filter.tags.includes(tag)"
          large
          @click="toggleTag(tag)"
        />
      </v-layout>
    </div>
    <v-layout justify-center mt-5>
      <v-flex sm6 xs12>
        <v-layout>
          <v-btn flat @click="clearFilter" to="/recipes"> Zrušit filtr </v-btn>
          <v-btn color="primary" block to="/recipes"> Zobrazit výsledky </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { SET_TAGS, TOGGLE_TAG } from "@/action-types";
import RecipeTag from "@/components/RecipeTag";

export default {
  name: "RecipesFilterPage",
  components: { RecipeTag },
  toolbar: {
    title: "Filtrovat recepty",
    background: "secondary",
    color: "transparent",
    back: true
  },
  computed: {
    filter() {
      return this.$store.state.filter;
    },
    tagGroups() {
      return this.$store.getters["tagGroups"];
    }
  },
  methods: {
    toggleTag(tag) {
      this.$store.commit(TOGGLE_TAG, tag);
    },
    clearFilter() {
      this.$store.commit(SET_TAGS, []);
    }
  }
};
</script>
